import type { VuetifyOptions } from 'vuetify'

const theme: VuetifyOptions['theme'] = {
  defaultTheme: 'light',
  themes: {
    light: {
      dark: false,
      colors: {
        primary: '#1867C0',
      },
    },
    dark: {
      dark: true,
      colors: {
        primary: '#2196F3',
      },
    },
  },
}

export default theme
